import { defineMessages } from 'react-intl';

export const useSourceControlMessages = defineMessages({
  regionLabel: {
    defaultMessage: 'Local', id: 'RowyAKAiVq',
    description: 'Short label for local or regional clinical guidelines source',
  },
  askHeidiAnything: {
    defaultMessage: 'Ask Heidi anything...', id: 'vziSUyvNb7',
    description: 'Chat input placeholder when web search is the selected source',
  },
  followUp: {
    defaultMessage: 'Ask a follow up question', id: 'JGJbxGei/6',
    description: 'Chat input placeholder for follow-up messages in source control v1',
  },
  localGuidelines: {
    defaultMessage: 'Look up {regionName} clinical guidance on...', id: 'fN/5jPqCRq',
    description:
      'Chat input placeholder when local guidelines are the selected source',
  },
  primaryEvidence: {
    defaultMessage: 'Explore research on...', id: 'eTiHtdiVkV',
    description: 'Chat input placeholder when primary evidence is the selected source',
  },
  evidenceAndGuidelines: {
    defaultMessage: 'Review clinical guidelines and research on...', id: 'HDpAYk1dUP',
    description:
      'Chat input placeholder when both evidence and guidelines are selected',
  },
  v2Default: {
    defaultMessage: 'Ask a question or start a task...', id: '/DqcopqX2V',
    description: 'Default chat input placeholder when source control v2 is enabled',
  },
  v2FollowUp: {
    defaultMessage: 'Ask a follow-up question...', id: 'wt2RUAzuU2',
    description: 'Follow-up chat input placeholder when source control v2 is enabled',
  },
});
